export default "https://static.wetvinfo.com/tv/linux/static/media/aboutUs_h.png";